import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import {
  getCompanyLastSelectedStateListData,
  getCompanyLastSelectedStateData,
} from './mockData'
import type { THrid } from '~/types/models'
import type { ICompanyLastSelectedState } from '~/types/company/models'

interface GetCompanyLastSelectedStateListDataResponse {
  data: ICompanyLastSelectedState[]
}

async function getCompanyLastSelectedListData(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const responseBody: GetCompanyLastSelectedStateListDataResponse = {
    data: await getCompanyLastSelectedStateListData(),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

interface GetCompanyLastSelectedStateResponse {
  data: ICompanyLastSelectedState
}

async function getCompanyLastSelectedState(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const { id } = req.params
  if (typeof id !== 'string') {
    const responseBody = {
      statusCode: 500,
      message: 'Passed ID is not a string.',
    }
    return res(ctx.status(500), ctx.json(responseBody))
  }
  const responseBody: GetCompanyLastSelectedStateResponse = {
    data: await getCompanyLastSelectedStateData(id),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

// post

interface PostCompanyLastSelectedStateResponse {
  hrid: THrid
}
const postCompanyLastSelectedState = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getCompanyLastSelectedStateListData)
}

const patchCompanyLastSelectedState = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(
    req,
    res,
    ctx,
    getCompanyLastSelectedStateListData
  )
}

const deleteCompanyLastSelectedState = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(
    req,
    res,
    ctx,
    getCompanyLastSelectedStateListData
  )
}

export const handlers = [
  {
    method: 'get',
    path: '/api/companylastselectedstates',
    handler: getCompanyLastSelectedListData,
  },
  {
    method: 'get',
    path: '/api/companylastselectedstates/:id',
    handler: getCompanyLastSelectedState,
  },
  {
    method: 'post',
    path: '/api/companylastselectedstates',
    handler: postCompanyLastSelectedState,
  },
  {
    method: 'patch',
    path: '/api/companylastselectedstates/:id',
    handler: patchCompanyLastSelectedState,
  },
  {
    method: 'delete',
    path: '/api/companylastselectedstates/:id',
    handler: deleteCompanyLastSelectedState,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
